import useCountryCode from '@haaretz/s-atoms/countryCode';
import useUser from '@haaretz/s-atoms/user';
import discardFields from '@haaretz/s-common-utils/discardFields';
import discardNullableValues from '@haaretz/s-common-utils/discardNullableValues';
import isAbandonedCartRoute from '@haaretz/s-pp-routing-utils/isAbandonedCartRoute';
import { usePPDataStore, usePPCouponStore } from '@haaretz/s-use-pp-data-store';
import { usePPOffsetStepsStore } from '@haaretz/s-use-pp-offset-steps-store';
import { useRouter } from 'next/router';
import React from 'react';
function getVariablesFromQuery(query, isLoggedIn) {
    const pathSegment = query.pathSegment;
    const cartData = isLoggedIn && isAbandonedCartRoute(query);
    const previousSteps = '';
    const selectedOfferId = query.selectedOfferId;
    const flow = query.flow;
    const currency = query.currency;
    const countryCode = query.countryCode;
    return {
        pathSegment,
        cartData,
        previousSteps,
        flow,
        currency,
        countryCode,
        ...selectedOfferId ? {
            selectedOfferId
        } : {}
    };
}
function usePpDataVariables(excludeValues) {
    const router = useRouter();
    const { contentId } = usePPDataStore();
    const couponId = usePPCouponStore();
    const offsetSteps = usePPOffsetStepsStore();
    const userData = useUser('cookieValue');
    const countryCode = useCountryCode();
    const previousSteps = offsetSteps.join(',');
    const variableFromQuery = React.useMemo(()=>getVariablesFromQuery(router.query, userData.isLoggedIn || false), [
        router.query,
        userData?.isLoggedIn
    ]);
    const result = React.useMemo(()=>discardNullableValues(discardFields({
            selectedOfferId: userData?.isLoggedIn ? contentId : undefined,
            ...variableFromQuery,
            couponId,
            previousSteps: variableFromQuery.previousSteps || previousSteps,
            countryCode
        }, excludeValues || [])), [
        contentId,
        countryCode,
        couponId,
        excludeValues,
        previousSteps,
        userData?.isLoggedIn,
        variableFromQuery
    ]);
    return result;
}
export function getPpDataVariableFromContext(ctx, isLoggedIn) {
    return discardNullableValues(getVariablesFromQuery(ctx.query, isLoggedIn));
}
export default usePpDataVariables;

//# sourceMappingURL=usePPDataVariables.js.map